import { createFileRoute } from '@tanstack/react-router'
import SmartQCDetail from '@/components/smartqc-detail-route'
import { navigateGuard } from '@/utils/auth'
import { UserRole } from '@/constants/user'

export const Route = createFileRoute('/_auth/smart-qc/autoQa/$smartQcId/')({
  beforeLoad: ({ location }) => {
    return navigateGuard(location, [UserRole.ADMINISTRATOR])
  },
  component: SmartQcDetailWrapper,
})

function SmartQcDetailWrapper() {
  const { smartQcId } = Route.useParams()

  return <SmartQCDetail smartQcId={smartQcId} />
}
